import { concat } from '@ember/helper';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { and, eq } from 'ember-truth-helpers';

import InfoBox from 'umg-ember-backend/components/ui/info-box';
import modelIcon from 'umg-ember-backend/helpers/model-icon';
import { getBem } from 'umg-ember-backend/utils/get-bem';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class PageBuilderOptionsSelectedInfoComponent extends Component {
  // Getter and setter
  get selectedType() {
    return (
      this.args.selectedModelToStyle.type ??
      getRecordType(this.args.selectedModelToStyle)
    );
  }

  // Template
  <template>
    <div class={{(bem)}}>
      <h3>
        {{#if (eq (getRecordType @selectedModelToStyle) 'mlp')}}
          {{t 'page_builder.options.selected_info.global_settings'}}
        {{else}}
          {{t (concat 'models.' this.selectedType)}}
          {{t 'page_builder.options.selected_info.settings'}}
        {{/if}}
      </h3>

      {{#if (eq (getRecordType @selectedModelToStyle) 'mlp')}}
        {{t 'page_builder.options.selected_info.global_message'}}
        {{#if (and @mlp.hasUnpublishedChanges @mlp.hasVisiblePublisheMlp)}}
          <InfoBox @type='warning' class='u-margin-bottom-small'>
            {{t 'page_builder.options.selected_info.unpublished_changes'}}
          </InfoBox>
        {{/if}}
      {{else}}
        <div class='o-layout'>
          <div class='o-layout__item u-1/4'>
            <div class={{bem 'item'}}>
              {{svgJar (modelIcon this.selectedType) class=(bem 'icon')}}
            </div>
          </div>
          <div class='o-layout__item u-3/4'>
            <strong>{{t 'page_builder.options.selected_info.type'}}:</strong>
            {{t (concat 'models.' this.selectedType)}}<br />
            <strong>{{t
                'page_builder.options.selected_info.headline'
              }}:</strong>
            {{@selectedModelToStyle.displayHeadline}}<br />
          </div>
        </div>

        {{#unless @selectedModelToStyle.visible}}
          <InfoBox
            @type='warning'
            class='u-margin-top-small u-margin-bottom-none'
          >
            {{t 'page_builder.options.selected_info.hidden_item'}}
          </InfoBox>
        {{/unless}}
      {{/if}}
    </div>
  </template>
}
